import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-logistics-solutions',
  templateUrl: './logistics-solutions.component.html',
  styleUrls: ['./logistics-solutions.component.scss']
})
export class LogisticsSoloutionComponent implements OnInit {

  constructor(private meta: Meta) { 
    this.meta.removeTag('name=keywords');
    this.meta.removeTag('name=description');
    this.meta.addTags([ 
      { name: 'description', content: 'Explore our Logistic Management System solution at OSIT. Streamline your supply chain and logistics operations with our advanced software and services. Enhance efficiency, reduce costs, and optimize your entire logistics process in Saudi Arabia. Discover how our expertise can transform your logistics management.' }, 
      { name: 'keywords', content: 'osit,it,saudi it,software development,website development' } 
  ]);
  }

  ngOnInit() {
  }

}
